import { EventsFilter } from '../../services/component-data-filter/data/events-filter';

export interface EventsState {
  calendar: {
    data: any[];
    loading: boolean;
    error: any;
    lastUpdated: number;
    lastQueryParams: Record<string, unknown> | null;
    pendingReplaceCache: boolean;
    pendingQueryParams: Record<string, unknown> | null;
  };
  filters: EventsFilter | null;
  pendingRequestId: string | null;
}

export const initialState: EventsState = {
  calendar: {
    data: [],
    loading: false,
    error: null,
    lastUpdated: 0,
    lastQueryParams: null,
    pendingReplaceCache: true,
    pendingQueryParams: null,
  },
  filters: null,
  pendingRequestId: null
};

